export enum Role {
  VisualArtistAdmin = "VA",
  MemberServices = "MS",
  Data = "Data",
  ResaleReporter = "resale_reporter",
  RoyaltyRecipient = "royalty_recipient",
}

export const ExternalRoles = [Role.ResaleReporter, Role.RoyaltyRecipient];
export const InternalRoles = [
  Role.VisualArtistAdmin,
  Role.MemberServices,
  Role.Data,
];

export const ResaleSubmissionRoles = [Role.ResaleReporter, Role.VisualArtistAdmin, Role.Data];
export const AllRoles = ExternalRoles.concat(InternalRoles);


export const checkRoleMembership = (userRoles: Role[], allowedRoles: Role[]) => {
  return userRoles.some((role) => allowedRoles.includes(role));
}